import React, { useState } from 'react';
import './TopNavigationBar.scss';
import { AppState } from '../../../store';
import { connect } from 'react-redux';
import { updateActivePopupType, updateProjectData } from '../../../store/general/actionCreators';
import { PopupWindowType } from '../../../data/enums/PopupWindowType';
import TextInput from '../../Common/TextInput/TextInput';
import StateBar from '../StateBar/StateBar';
import {ImageButton} from '../../Common/ImageButton/ImageButton';
import {Settings} from '../../../settings/Settings';
import {ProjectData} from '../../../store/general/types';
import DropDownMenu from './DropDownMenu/DropDownMenu';
import { store } from '../../../../src';
import { PolygonLabelsExporter } from '../../../logic/export/polygon/PolygonLabelsExporter';
import { AnnotationFormatType } from '../../../data/enums/AnnotationFormatType';

interface IProps {
    updateActivePopupTypeAction: (activePopupType: PopupWindowType) => any;
    updateProjectDataAction: (projectData: ProjectData) => any;
    projectData: ProjectData;
}

const TopNavigationBar: React.FC<IProps> = (props) => {
    const [isSaving, setIsSaving] = useState(false);
    // let search = window.location.search;
    // let params = new URLSearchParams(search);
    // let image = params.get('image');
    // let nameImageArr = image.split("PheromoneTrap_");
    // let nameImage = nameImageArr[1].substring(0,7);
    // props.updateProjectDataAction({
    //     ...props.projectData,
    //     name: nameImage
    // })
    const onFocus = (event: React.FocusEvent<HTMLInputElement>) => {
        event.target.setSelectionRange(0, event.target.value.length);
        
    };

    const onChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const value = event.target.value
            .toLowerCase()
            .replace(' ', '-');

        props.updateProjectDataAction({
            ...props.projectData,
            name: value
        })
    };
    const saveData = () => {
        if (isSaving) {
            return;
        }
        
        setIsSaving(true);
        // Call save functionality directly instead of opening popup
        PolygonLabelsExporter.export(AnnotationFormatType.COCO, "save");
        
        // Reset saving state after a delay to allow for the API call
        setTimeout(() => {
            setIsSaving(false);
        }, 3000);
    };
    const closePopup = () => props.updateActivePopupTypeAction(PopupWindowType.EXIT_PROJECT)

    return (
        <div className='TopNavigationBar'>
            <StateBar/>
            <div className='TopNavigationBarWrapper'>
                <div className='NavigationBarGroupWrapper'>
                    {/* <div
                        className='Header'
                        onClick={closePopup}
                    >
                        <img
                            draggable={false}
                            alt={'make-sense'}
                            src={'/dk-ms-ico-transparent.png'}
                        />
                        Make Sense
                    </div> */}
                </div>
                <div className='NavigationBarGroupWrapper'>
                    <DropDownMenu/>
                </div>
                <div className='NavigationBarGroupWrapper middle'>
                    <div className='ProjectName'>Project Name:</div>
                    <TextInput
                        isPassword={false}
                        value={props.projectData.name}
                        onChange={onChange}
                        onFocus={onFocus}
                    />
                </div>
                <div className='NavigationBarGroupWrapper'>
                <button 
                    className="ButtonStyle" 
                    type="button" 
                    onClick={saveData}
                    disabled={isSaving}
                >
                    {isSaving ? 'Saving...' : 'Save'}
                </button>
                    {/* <ImageButton
                        image={'ico/github-logo.png'}
                        imageAlt={'github-logo.png'}
                        buttonSize={{width: 30, height: 30}}
                        href={Settings.GITHUB_URL}
                    /> */}

                </div>
            </div>
        </div>
    );
};

const mapDispatchToProps = {
    updateActivePopupTypeAction: updateActivePopupType,
    updateProjectDataAction: updateProjectData
};

const mapStateToProps = (state: AppState) => ({
    projectData: state.general.projectData
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(TopNavigationBar);
